/**
 * Formatting bound to the active language (FE-03 FR-FE03-21). Implementations live in
 * `@sos/ui` (format); components import from here so they never pass the language by hand.
 */
import { formatDate as uiFormatDate } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/packages/frontend/ui/src/format/index.ts";
import { formatDateTime as uiFormatDateTime } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/packages/frontend/ui/src/format/index.ts";
import { formatDistance as uiFormatDistance } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/packages/frontend/ui/src/format/index.ts";
import { formatMoney as uiFormatMoney } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/packages/frontend/ui/src/format/index.ts";
import { formatNumber as uiFormatNumber } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/packages/frontend/ui/src/format/index.ts";
import { formatPercent as uiFormatPercent } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/packages/frontend/ui/src/format/index.ts";
import { formatRelative as uiFormatRelative } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/packages/frontend/ui/src/format/index.ts";
import { formatRelativeDay as uiFormatRelativeDay } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/packages/frontend/ui/src/format/index.ts";
import { formatTime as uiFormatTime } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/packages/frontend/ui/src/format/index.ts";
import { todayInCostaRica } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/packages/frontend/ui/src/format/index.ts";

import { currentLanguage } from "../../app/i18n";

export { formatCount } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/packages/frontend/ui/src/components/CountBadge.tsx";
export { formatPhone } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/packages/frontend/ui/src/format/index.ts";
export { phoneHref } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/packages/frontend/ui/src/format/index.ts";

/** Money by the currency in the data with minor units: `{amount_minor, currency}`. */
export const formatMoney = (money: Money) => uiFormatMoney(money, currentLanguage());
/** Plain `YYYY-MM-DD` dates are not shifted; timestamps are shown in America/Costa_Rica. */
export const formatDate = (value: string | Date, style?: DateStyle) =>
  uiFormatDate(value, currentLanguage(), style);
export const formatTime = (value: string | Date) => uiFormatTime(value, currentLanguage());
export const formatDateTime = (value: string | Date) => uiFormatDateTime(value, currentLanguage());
export const formatRelative = (value: string | Date, now?: Date) =>
  uiFormatRelative(value, currentLanguage(), now);
export const formatNumber = (value: number) => uiFormatNumber(value, currentLanguage());
export const formatPercent = (ratio: number) => uiFormatPercent(ratio, currentLanguage());
export const formatDistance = (metres: number) => uiFormatDistance(metres, currentLanguage());

let businessToday: string | null = null;

/**
 * The business date from `me.today` (BE-05; staging time travel moves it, FE-03 FR-FE03-23).
 * Without a session, today in Costa Rica.
 */
export function setBusinessToday(value: string | null | undefined): void {
  businessToday = value && /^\d{4}-\d{2}-\d{2}$/.test(value) ? value : null;
}

export function today(): string {
  return businessToday ?? todayInCostaRica();
}

/** "vence mañana": a calendar date relative to the business today. */
export const formatRelativeDay = (date: string) =>
  uiFormatRelativeDay(date, today(), currentLanguage());
